import ActionTypes from '@constants/action_types.js'

export function receiveComments(comments) {
  return {
    type: ActionTypes.RECEIVE_TIMELINE_COMMENTS,
    payload: comments,
  }
}
